/*
 * @Description: 失效
 * @Date: 2020-12-12 17:49:04
 */
import fields from './fields';
import { projectPriceHanderl } from './fields';

import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import {
  listInvalidPayOrderPeopleAndSupplie,
  totalInvalidPayOrderPeopleAndSupplie
} from '@/api/ajax';

let example = new TableRenderClass({ fields, search });

// 页面入口
const part = example.createPart({
  name: '订单详情',
  search: [
    'orderNo',
    'projectName',
    'createDate',
    'fullName',
    'payee',
    'phone'
  ],
  list: listInvalidPayOrderPeopleAndSupplie,
  requestNow: true,
  fields: [
    'index',
    'orderNo',
    'payProjectStructureType',
    'payee',
    'userPhone',
    'projectName',
    'createDate',
    'finishSum',
    'taskPrice',
    'finishSumTaskPrice',
    projectPriceHanderl(4),
    'payStatus03',
    'finishPayDt',
    'download'
  ]
});

// individualAjax 为独立注册字段，用于获取总价接口
export default {
  name: '订单详情',
  childMenu: [{ ...part, individualAjax: totalInvalidPayOrderPeopleAndSupplie }]
};
